import styled from "styled-components";

const MyBalanceWidgetWrapper = styled.div``;

export default MyBalanceWidgetWrapper;
